export default __webpack_public_path__ + "static/media/BRZ.103459fb.png";